module.exports = __webpack_public_path__ + "static/media/calendar_canceled_event.4be9e541.svg";